<app-cargador *ngIf="AppServices.HabilitarCargador"></app-cargador>
<div>
  <app-datos [Constantes]="Constantes" [Mensajes]="Mensajes"></app-datos>    
  <div></div>
  <div></div>
  <app-admin-datos [Mensajes]="Mensajes" *ngIf="SoloAdmin"></app-admin-datos>
</div>